<section class="container-section" *ngIf="!isOpened">
    <div class="row">
        <form class="needs-validation container-style" novalidate [formGroup]="formMeter">
            <div class="ps-2 pe-2">
                <div class="row pt-1">
                    <div class="col">
                        <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true"
                            [label]="'Regresar'" [width]="'6rem'" [routerLink]="['/', url]" [severity]="null">
                        </app-custom-button>
                    </div>
                    <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
                        <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
                    </div>
                    <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
                        <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
                            (onClick)="deleteMeter()">
                        </app-custom-button>
                        <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                            [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                            (onClick)="createNewRegister()">
                        </app-custom-button>
                    </div>
                    <hr class="my-1">
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <app-custom-audit-info [userNameCreate]="meterModel.userNameCreate"
                            [createDate]="meterModel.createDate" [userNameUpdate]="meterModel.userNameUpdate"
                            [updateDate]="meterModel.updateDate" [reserveSpace]="true"></app-custom-audit-info>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-12">
                    <div class="row">
                        <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                            <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                                [recovery]="true" [required]="true" (onChangeSelect)="changeBranch($event)">
                            </app-custom-select>
                        </div>
                        <div class="col-lg-1 col-md-2 col-sm-2 col-12">
                            <app-custom-input-number formControlName="consecutive" [labelText]="'Código'"
                                [required]="true" [recovery]="true" (onChangeNumber)="changeConsecutive($event)">
                            </app-custom-input-number>
                        </div>
                        <div class="col-lg-1 col-md-3 col-sm-3 col-5">
                            <app-custom-datepicker class="w-100" formControlName="startDateMeter"
                                [labelText]="'Fecha Inicio'" (onChangeDate)="calculateDays()">
                            </app-custom-datepicker>
                        </div>
                        <div class="col-lg-1 col-md-3 col-sm-3 col-5">
                            <app-custom-datepicker class="w-100" formControlName="endDateMeter"
                                [labelText]="'Fecha Fin'" (onChangeDate)="calculateDays()">
                            </app-custom-datepicker>
                        </div>
                        <div class="col-auto d-flex align-items-end">
                            <app-custom-chip [label]="totalDays + ' días'" />
                        </div>
                        <div class="col-lg-1 col-md-2 col-sm-2 col-10">
                            <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateMeter">
                            </app-custom-tag>
                        </div>
                        <div class="col-auto d-flex align-items-end">
                            <app-custom-button [title]="titleState" [icon]="iconState" [severity]="'primary'"
                                (onClick)="changeMeterState()">
                            </app-custom-button>
                        </div>
                        <div class="col-lg-4 col-md-9 col-sm-8 col-12 ms-auto">
                            <app-custom-textarea class="w-100" formControlName="observation" [labelText]="'Observación'"
                                [autoResize]="false" [rows]="1" [maxLength]="250">
                            </app-custom-textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div
                            class="col-lg-12 col-md-12 col-12 d-flex justify-content-center justify-content-sm-end mt-2">
                            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'"
                                [variant]="undefined" [disabled]="disabledForm" (onClick)="send()">
                            </app-custom-button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-meter-detail [meterModel]="meterModel" [disabledDetail]="disabledForm"
            (hasQuantityInZero)="hasQuantityInZero = $event" [permissionUpdatable]="permissionUpdatable"
            (emitQuantityDetails)="quantityDetails = $event">
        </app-meter-detail>
    </div>
</section>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
    <span class="material-icons me-1"> highlight_off </span>
    <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>